import React from 'react';

import PriceSpan from 'common/components/formatters/PriceSpan';
import PropTypes from 'prop-types';

export default class SavingsBreakdown extends React.Component {
  static propTypes = {
    annualAmountSavings: PropTypes.number.isRequired,
  };

  render() {
    const { annualAmountSavings } = this.props;

    return (
      <div className="row">
        <div className="col-xs-10 col-xs-offset-1 CalculatorTrigger">
          <div className="h6 navy SavingsBreakdown__title">Your Savings</div>
          <div className="SavingsBreakdown__separator" />
          <div className="SavingsBreakdown__savings-wrapper">
            <div className="uppercase bold SavingsBreakdown__savings-title">
              total yearly savings
            </div>
            <PriceSpan
              className="SavingsBreakdown__total-savings flat-blue"
              amount={annualAmountSavings}
            />
          </div>
          <div className="row">
            <div className="text SavingsBreakdown__savings-text col-xs-offset-1 col-xs-10">
              If your JUULpod usage is constant to your cigarette usage, you
              would spend <PriceSpan amount={annualAmountSavings} />
              <sup>*</sup> more per year by smoking combustible cigarettes.
            </div>
          </div>
          <div className="row">
            <div className="SavingsBreakdown__did-you-know-wrapper pale-grey-background col-xs-12 col-md-8 col-md-offset-2">
              <div className="flat-blue bold text SavingsBreakdown__did-you-know">
                DID YOU KNOW?
              </div>
              <div className="navy text">
                Each JUULpod is approximately equivalent to 1 pack of cigarettes
                (20) or 200 puffs.
              </div>
              <div className="text--small">
                * does not include applicable taxes.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/calculator/components/SavingsBreakdown.js